import React, { useState } from "react";
import Cookies from "js-cookie";
import { TailSpin, ThreeDots } from "react-loader-spinner";
import { postApi } from "../../utils/api";
import { toast } from "react-toastify";
import * as Yup from "yup";
import validations from "../../config/validation";
import { API_APPROVE_ACCESS_REQUEST_IT } from "../../config/Endpoints";

const ApproveAccessRequestITForm = ({ accessId, header, onStatusUpdate }) => {
  const [formData, setFormData] = useState({ action: "", comment: "" });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = Cookies.get("accessToken");

  const validationSchema = Yup.object().shape({
    action: Yup.string().required("Please select an action."),

    comment: Yup.string()
      .trim()
      .when("action", {
        is: "APPROVED",
        then: (schema) =>
          schema
            .min(5, "Description must be at least 5 characters.")
            .required("Description is required."),
        otherwise: (schema) =>
          schema
            .min(5, "Reason must be at least 5 characters.")
            .required("Reason is required."),
      }),
  });
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "action") {
      setErrors((prev) => ({ ...prev, action: "", comment: "" }));
    } else {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleReset = () => {
    setFormData({ action: "", comment: "" });
    setErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await validationSchema.validate(formData, { abortEarly: false });
      setIsLoading(true);

      const { action, comment } = formData;
      const statusValue = action === "APPROVED" ? true : false;

      const response = await postApi(
        `${API_APPROVE_ACCESS_REQUEST_IT}/${accessId}?approved=${statusValue}&comment=${encodeURIComponent(
          comment,
        )}`,
        {},
        accessToken,
      );

      if (response?.status === 200 || response?.data?.statusCode === 200) {
        toast.success(response.data?.message || "Request updated successfully");
        onStatusUpdate && onStatusUpdate(accessId, formData.action);
        document.querySelector(".cancel-modal").click();
      } else {
        toast.error(response?.data?.message || "Something went wrong.");
      }
    } catch (error) {
      if (error.inner) {
        const errs = {};
        error.inner.forEach((err) => (errs[err.path] = err.message));
        setErrors(errs);
      } else {
        toast.error("Something went wrong.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {isLoading && (
        <div className="overlay">
          <TailSpin height="80" width="80" color="blue" />
        </div>
      )}

      <div className="modal-header">
        <h5 className="modal-title text-center flex">{header}</h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          onClick={handleReset}
        ></button>
      </div>

      <div className="modal-body">
        <div className="row mt-3">
          <div className="col-md-2"></div>
          <div className="col-md-4">
            <label htmlFor="action" className="has-asterisk">
              Action
            </label>
          </div>
          <div className="col-md-4">
            <select
              name="action"
              className="border w-100"
              value={formData.action}
              onChange={handleChange}
              required
            >
              <option value="" disabled>
                Select Action
              </option>
              <option value="APPROVED">Approve</option>
              <option value="REJECTED">Reject</option>
            </select>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-2"></div>
          <div className="col-md-4">
            <label htmlFor="comment" className="has-asterisk">
              {formData.action === "REJECTED" ? "Reason" : "Description"}
            </label>
          </div>
          <div className="col-md-4">
            <textarea
              rows={3}
              name="comment"
              className="border
              "
              value={formData.comment}
              onChange={handleChange}
              required
            ></textarea>
            {errors.comment && (
              <small className="text-danger">{errors.comment}</small>
            )}
          </div>
        </div>
      </div>

      <div className="modal-footer justify-content-center">
        <button
          type="submit"
          className={`theme-button ${isLoading ? "disabled" : ""}`}
        >
          {isLoading ? (
            <ThreeDots height="20" width="50" color="white" />
          ) : (
            "Submit"
          )}
        </button>
        <button
          type="button"
          className="theme-button bg-grey mx-3 cancel-modal"
          data-bs-dismiss="modal"
          onClick={handleReset}
        >
          Cancel
        </button>
      </div>
    </form>
  );
};

export default ApproveAccessRequestITForm;
